import { render, staticRenderFns } from "./RequestCancelOrder.vue?vue&type=template&id=64a3161d&scoped=true"
var script = {}
import style0 from "./RequestCancelOrder.vue?vue&type=style&index=0&id=64a3161d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3161d",
  null
  
)

export default component.exports